export const nameInitials = (fullName: string | undefined) =>
  fullName
    ?.split(' ')
    .map((name) => name[0])
    .join('')
